export const photos = [
    {
      id: 1,
      title: "Photo Gallery",
      image: "/photos/p1.JPG",
      category: "Events"
    },
    {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p2.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p3.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p4.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p5.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p6.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p7.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p8.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p9.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p10.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p11.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p12.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p13.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p14.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p15.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p16.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p17.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p18.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p19.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p20.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p21.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p22.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p23.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p24.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p25.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p26.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p27.jpg",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p28.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p29.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p30.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p31.JPG",
        category: "Events"
      },
      {
        id: 1,
        title: "Photo Gallery",
        image: "/photos/p32.jpg",
        category: "Events"
      }
    
  ];
